export default [
  {
    title: 'Upcoming Tasks',
    route: 'my-task-list',
    icon: 'CheckCircleIcon',
    resource: 'myTask',
    action: 'read',
  },
  {
    title: 'Task Templates',
    route: 'my-process-list',
    icon: 'CopyIcon',
    resource: 'myProcess',
    action: 'read',
  },
]
